import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/clients/client";
import { Request } from "types/request";
import { Response } from "types/response";

export interface UserDelete {
  subscriptionId: number;
  userId: number;
  delete: boolean;
}

export default function useDeleteUser() {
  const queryClient = useQueryClient();

  const deleteUser = (userDelete: UserDelete) => {
    const request: Request = {
      url: `${ENDPOINTS.user.main}`,
      config: {
        method: "delete",
        data: userDelete,
      },
    };
    return client(request);
  };

  return useMutation<Response<null>, Error, UserDelete>(deleteUser, {
    onSettled: (result, error, variables) => {
      queryClient.invalidateQueries([ENDPOINTS.subscription.users]);
      queryClient.invalidateQueries([
        ENDPOINTS.subscription.users,
        variables.subscriptionId,
      ]);
    },
  });
}
